import { useState, useEffect } from 'react';

/**
 * Normalize deprecated roles to current equivalents.
 * compliance_manager → manager, viewer → user
 */
function normalizeRole(role) {
  if (role === 'compliance_manager') return 'manager';
  if (role === 'viewer') return 'user';
  return role;
}

export const usePermissions = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [permissions, setPermissions] = useState({
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canManageUsers: false,
    canManageAdmins: false,
    isOwner: false,
    isAdmin: false,
    isSuperAdmin: false,
  });

  useEffect(() => {
    const userStr = sessionStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setCurrentUser(user);

        const role = normalizeRole(user.role || 'user');
        
        // Define permissions based on role hierarchy:
        // Owner > Admin > Manager > User
        const rolePermissions = {
          super_admin: {
            canView: true,
            canCreate: true,
            canEdit: true,
            canDelete: true,
            canManageUsers: true,
            canManageAdmins: true,
            isOwner: false,
            isAdmin: true,
            isSuperAdmin: true,
          },
          owner: {
            canView: true,
            canCreate: true,
            canEdit: true,
            canDelete: true,
            canManageUsers: true,
            canManageAdmins: true,
            isOwner: true,
            isAdmin: true,
            isSuperAdmin: false,
          },
          admin: {
            canView: true,
            canCreate: true,
            canEdit: true,
            canDelete: true,
            canManageUsers: true,
            canManageAdmins: false,
            isOwner: false,
            isAdmin: true,
            isSuperAdmin: false,
          },
          manager: {
            canView: true,
            canCreate: true,
            canEdit: true,
            canDelete: false,
            canManageUsers: false,
            canManageAdmins: false,
            isOwner: false,
            isAdmin: false,
            isSuperAdmin: false,
          },
          user: {
            canView: true,
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canManageUsers: false,
            canManageAdmins: false,
            isOwner: false,
            isAdmin: false,
            isSuperAdmin: false,
          },
        };

        setPermissions(rolePermissions[role] || rolePermissions.user);
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  return { currentUser, ...permissions };
};
